import clsx from 'clsx';
import Input from 'components/atoms/TextInput/Input';
import Txt from 'components/atoms/Txt/Txt';
import { FormControllerContext } from 'components/molecules/Form/Form';
import React, { HTMLProps, PropsWithoutRef, useContext, useEffect, useId } from 'react';
import classes from './Checkbox.module.scss';

export type Props = {
  labelElement?: React.ReactNode;
  className?: string;
  skipTranslation?: boolean;
  id?: string;
} & PropsWithoutRef<HTMLProps<HTMLInputElement>>;

export function Checkbox({
  label,
  labelElement,
  className,
  name,
  id,
  skipTranslation,
  ...rest
}: Props) {
  const formController = useContext(FormControllerContext);
  const [isValid, setIsValid] = React.useState(
    Boolean(!rest.required || !(!rest.readOnly && !rest.disabled && !rest.hidden)),
  );
  const generatedId = useId();
  const identifier: string = id ?? generatedId;

  useEffect(() => {
    formController.notifyChange(identifier, isValid);
  }, [identifier, formController, isValid]);

  function handleChange(e: React.FormEvent<HTMLInputElement>) {
    setIsValid(e.currentTarget.checked);
  }

  return (
    <label htmlFor={identifier} className={clsx(classes.root, className)}>
      <Input
        type="checkbox"
        id={identifier}
        name={name}
        onChange={handleChange}
        className={clsx(classes.input)}
        {...rest}
      />
      <Txt component="div" className={clsx(classes.labelWrapper)} skipTranslation={skipTranslation}>
        {label || labelElement}
      </Txt>
    </label>
  );
}
